<template>
    <div>
        <el-dialog
            :title="title"
            :visible.sync="showdialog"
            width="1200px"
            @close="back">
            
            <div class="base-warp">
                <div class="head">
                    <el-form :model="form" label-width="80px" :inline="true" size="mini">
                        <el-form-item label="客户姓名">
                            <el-input v-model="form.name" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="状态">
                            <el-select v-model="form.finish" placeholder="请选择" clearable filterable>
                                <el-option label="完成" :value="true"></el-option>
                                <el-option label="未完成" :value="false"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="时间">
                            <el-date-picker
                                v-model="form.date"
                                type="daterange"
                                range-separator="至"
                                value-format="yyyy-MM-dd"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="search">搜索</el-button>
                        </el-form-item>
                        <el-form-item>
                            <tutor-add :id="id"></tutor-add>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="table-box">
                    <el-table 
                    :data="tableData" 
                    border 
                    :header-cell-style="{background:'#f7f7f7',color:'#999', textAlign: 'center', fontWeight: 'normal'}">
                        <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
                        <el-table-column prop="name" label="姓名" align="center"></el-table-column>
                        <el-table-column prop="finish" label="状态" align="center">
                            <template slot-scope="s">
                                <span class="text-success" v-if="s.row.finish">完成</span>
                                <span class="text-danger" v-else>未完成</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="telephone" label="手机" align="center"></el-table-column>
                        <el-table-column prop="intention" label="意向" align="center"></el-table-column>
                        <el-table-column prop="budget" label="预算" align="center"></el-table-column>
                        <el-table-column label="上次跟进" align="center"></el-table-column>
                        <el-table-column prop="name" label="操作" align="center">
                            <template slot-scope="s">
                                <tutor-log :id="s.row._id['$oid']" :key="s.row._id['$oid']"></tutor-log>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <el-pagination class="page-tion"
                    @current-change="currentChange"
                    layout="prev, pager, next"
                    :page-size="pagesize"
                    :total="total" background>
                </el-pagination>
            </div>

        </el-dialog>
        
    </div>
</template>

<script>
import tutorAdd from '../../../components/tutor-add.vue'
import TutorAdd from '../../../components/tutor-add.vue'
import TutorLog from '../../../components/tutor-log.vue'
export default {
    components: { TutorAdd, TutorLog },
    data() {
        return {
            showdialog: true,
            title: '',
            id: '',
            form: {
                name: '',
                finish: '',
                date: '',
            },
            tableData: [],
            pageNo: 1,
            pagesize: 10,
            total: 0,
        }
    },
    mounted () {
        this.id = this.$route.query.id;
        this.title = this.$route.query.name+'的成功案例';
        this.getTableData();
    },
    methods: {
        logs() {

        },
        getTableData() {
            var params = {
                id: this.id,
                name: this.form.name,
                finish: this.form.finish,
                date: this.form.date,
                pageNo: this.pageNo,
                pagesize: this.pagesize,
            }
            this.$api.getTutorCaseList(params).then(
                data=>{
                    let {list, total} = data;
                    this.tableData = list;
                    this.total = total;
                }
            )
        },
        back() {
            this.$router.go(-1);
        },
        search() {
            this.pageNo = 1;
            this.getTableData();
        },
        currentChange(page) {
            this.pageNo = page;
            this.getTableData();
        },
    },
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header{
    border-bottom: 1px solid #f7f7f7;
}
</style>